document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-bw-carousel]').forEach(function(carousel){
    var track=carousel.querySelector('.bw-carousel__track');
    var slides=carousel.querySelectorAll('.bw-carousel__slide');
    var previous=carousel.querySelector('[data-carousel-prev]');
    var next=carousel.querySelector('[data-carousel-next]');
    if(slides.length<2){
      if(previous){previous.hidden=true;}
      if(next){next.hidden=true;}
      return;
    }
    function move(direction){
      track.scrollBy({left:direction*track.clientWidth,behavior:'smooth'});
    }
    if(previous){previous.addEventListener('click',function(){move(-1);});}
    if(next){next.addEventListener('click',function(){move(1);});}
  });
  document.querySelectorAll('.bw-reserve-form,.bw-product-form').forEach(function(form){
    var select=form.querySelector('select[name="id"]');
    var button=form.querySelector('button[type="submit"]');
    if(!select||!button){return;}
    function sync(){button.disabled=!select.value;}
    select.addEventListener('change',sync);
    sync();
  });
});
